import React from 'react'
import { MerchantProvider } from './merchant-context'

export const DisputebotListProvider = ({ children }) => (
  <MerchantProvider>{children}</MerchantProvider>
)
